const routes = {
  overview: "overview",
  functions: "functions",
  pricing: "pricing",
  faq: "faq",
  contacts: "contacts",
};

export default routes;
